var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 275.072 275.072",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.69,0H71.38c-9.884,0-17.926,8.05-17.926,17.945v239.192c0,9.889,8.041,17.935,17.926,17.935H203.69 c9.886,0,17.928-8.045,17.928-17.935V17.945C221.618,8.05,213.576,0,203.69,0z M206.618,257.138c0,1.618-1.313,2.935-2.928,2.935 H71.38c-1.586,0-2.926-1.344-2.926-2.935V17.945c0-1.624,1.312-2.945,2.926-2.945H203.69c1.614,0,2.928,1.321,2.928,2.945V257.138z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.843,24h-29.73c-11.391,0-20.658,9.268-20.658,20.659c0,11.391,9.267,20.658,20.658,20.658h29.73 c11.391,0,20.658-9.267,20.658-20.658C148.501,33.268,139.233,24,127.843,24z M127.843,50.317h-29.73 c-3.12,0-5.658-2.538-5.658-5.658c0-3.121,2.538-5.659,5.658-5.659h29.73c3.12,0,5.658,2.539,5.658,5.659 C133.501,47.779,130.963,50.317,127.843,50.317z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9aa9c59088d33afee662defbd2e7cfe5.svg";
export { ForwardRef as ReactComponent };